import React from "react";

export const PaymentCancelledPage = (props) => {
  return (
    <div>
      <div
        className="sticky-md-top"
        style={{
          backgroundColor: "#f3f3f3",
          boxShadow: "0 .5rem 1rem -.5rem rgba(0,0,0,.15)",
        }}
      >
        <div className="row">
          <div className="col-12 mt-3 mb-1 ms-3">
            <h4 className="text-uppercase">Payment Cancelled</h4>
          </div>
        </div>
      </div>
      <div className="container mt-5">
        <div>Your PayPal payment for Shopify Order #{props.match.params.shopify_order_number} was cancelled.</div>
        <div className="mt-5">
          <a href="/orders">Return to My Orders</a>
        </div>
      </div>
    </div>
  );
};
